module.exports = __webpack_public_path__ + "img/0110.a954a033.png";